function useIsNew(): boolean {
  return window.location.href.includes("new")
}

export default useIsNew
